import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { StyleSheet } from "react-native";
import hoistNonReactStatics from "hoist-non-react-statics";
import GestureHandlerRootView from "./GestureHandlerRootView";
export default function gestureHandlerRootHOC(Component, containerStyles) {
    function Wrapper(props) {
        return /*#__PURE__*/ _jsx(GestureHandlerRootView, {
            style: [
                styles.container,
                containerStyles
            ],
            children: /*#__PURE__*/ _jsx(Component, _object_spread({}, props))
        });
    }
    Wrapper.displayName = "gestureHandlerRootHOC(".concat(Component.displayName || Component.name, ")");
    // @ts-ignore - hoistNonReactStatics uses old version of @types/react
    hoistNonReactStatics(Wrapper, Component);
    return Wrapper;
}
var styles = StyleSheet.create({
    container: {
        flex: 1
    }
});
